<template>
<div>
  <section id="loading-screen">

    <div id="loader">
      <h2>Loading in progress
      <animated-number :value="this.message.percent" :duration="this.message.duration" :formatValue="this.formatToPercent" /></h2>

    </div>

  </section>

  <teaserInfo></teaserInfo>

  <div :id="this.name"></div>
</div>
</template>

<script>
import anime from 'animejs'
import teaserInfo from './teaserInfo'
import AnimatedNumber from './animatedNumber.vue';

import 'imports-loader?THREE=three!../../static/GLTFLoader.js'

export default {
  data() {
    return {
      name: 'mainpage',
      message: {
        percent: 0,
        duration: 50
      },
      animation: {
        start: false,
        finished: false,
        duration: 5000,
        delay: 2500,
        dayCycle: 4000
      },
      cameraParameters: {
        fov: 110,
        focalPoint: {
          x: 50,
          y: 600,
          z: 0
        }
      },
      sunParameters: {
        distance: 500,
        inclination: 0.25,
        azimuth: 0
      },
      options: {
        shadowClip: 1000,
      },
      rendererThree: null,
      scene: null,
      sphere: null,
      light: null,
      camera: null,
      shadowPlane: null,
      plane: null,
      sky: null,
      controls: null,
      cubeCamera: null,
      cubeCamera2: null,
      model: null,
      modelMaterial: null,
      ambientLight: null,
      texLoader: null,
      loaded: false,
      count: 0,
      nightSky: null,
      isNight: false,
      group: null,
      loadingScreen: null,
      manager: null
    }
  },
  components: {
    teaserInfo,
    AnimatedNumber
  },
  methods: {
    init() {
      this.rendererThree = new THREE.WebGLRenderer({
        antialias: false,
        preserveDrawingBuffer: false,
        alpha: false
      });

      var width = window.innerWidth;
      var height = window.innerHeight;
      this.rendererThree.setSize(width, height);

      var minPixelRatio = 1.25;
      var PixelRatio = Math.min(minPixelRatio, window.devicePixelRatio)

      this.rendererThree.setPixelRatio(PixelRatio);
      this.rendererThree.domElement.id = 'threeJsCanvas';
      this.rendererThree.setClearColor(0x111111, 0);
      this.rendererThree.toneMapping = THREE.LinearToneMapping;
      this.rendererThree.gammaInput = true;
      this.rendererThree.gammaOutput = true;
      this.rendererThree.gammaFactor = 1.0;





      this.group = new THREE.Group();
      this.group.name = 'group';

      document.getElementById(this.name).appendChild(this.rendererThree.domElement);

      this.scene = new THREE.Scene();
      this.scene.name = 'scene';

      this.loadingManager();
      this.texLoader = new THREE.TextureLoader(this.manager);

      this.initCamera();
      this.initCubeCamera();
      this.initLights();


      this.initNightSky();
      this.initModel();
      this.initSphere();
      this.initShadowPlane();
      this.initControls(true);

      this.initSkybox();
      this.camera.lookAt(new THREE.Vector3(0, this.cameraParameters.focalPoint.y, 0));


      this.scene.add(this.group);

      this.rendererThree.shadowMap.enabled = true;
      this.rendererThree.shadowMap.type = THREE.PCFShadowMap;

      //  console.log(this.rendererThree.info);
      //window.scene = this.scene;

    },
    loadingManager() {
      var self = this;
      this.manager = new THREE.LoadingManager();
      this.manager.onStart = function(url, itemsLoaded, itemsTotal) {
        //    console.log('Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
      };
      this.manager.onLoad = function() {
        //    console.log('Loading complete!');
        //  self.loaded = true;
      };
      this.manager.onProgress = function(url, itemsLoaded, itemsTotal) {
        self.message.percent = (itemsLoaded / itemsTotal) * 100;

        //    console.log('Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
      };
      this.manager.onError = function(url) {
        //  console.log('There was an error loading ' + url);
      };
    },
    loadingComplete() {
      if (this.loaded) {
        this.animate();
      }
    },
    animate() {
      if (this.loaded) {
        if (this.animation.start) {
          this.nightSky.rotation.y += 0.0005;
          this.group.rotation.y += 0.0025;
        }
        if (this.animation.finished) {
          this.controls.update();

          this.camera.lookAt(new THREE.Vector3(0, 400, 0));
        }
        //  this.rendererThree.autoClear = true;

        if (this.count % 2 === 0) {
          this.model.visible = false;
          this.cubeCamera2.position.copy(this.model.position);
          this.cubeCamera2.update(this.rendererThree, this.scene);
          this.model.visible = true;
        } else {
          this.sphere.visible = false;

          this.cubeCamera.position.copy(this.sphere.position);
          this.cubeCamera.update(this.rendererThree, this.scene);
          this.sphere.visible = true;

        }

        this.count++;
        this.rendererThree.toneMappingExposure = Math.pow(1.0, 4.0);
        requestAnimationFrame(this.animate);

        this.rendererThree.render(this.scene, this.camera);

        //   this.rendererThree.autoClear = false;
      }
    },
    initControls(bool) {
      this.controls = new THREE.OrbitControls(this.camera, document.querySelector('#teaserInfo'));
      this.controls.enableZoom = true;
      this.controls.enabled = bool;
      this.controls.enablePan = false;
      this.controls.enableKeys = false;
      this.controls.enableRotation = true;
      this.controls.enableDamping = true;
      this.controls.rotateSpeed = 0.25;


      this.controls.maxPolarAngle = Math.PI / 2 - 0.15;

      this.controls.minDistance = 200.0;
      this.controls.maxDistance = 4000.0;
      this.controls.target.set(0, 0, 0);

      if (bool) {
        document.getElementById('threeJsCanvas').style.pointerEvents = 'auto';
        this.controls.update();
      }
    },
    initCamera() {
      this.camera = new THREE.PerspectiveCamera(this.cameraParameters.fov, window.innerWidth / window.innerHeight, 1, 10000);
      this.camera.name = 'camera';
      this.camera.position.set(-120, this.cameraParameters.focalPoint.y, 120);
      // var helper = new THREE.CameraHelper(this.camera);
      // this.scene.add(helper);
      this.scene.add(this.camera);
    },
    initCubeCamera() {
      this.cubeCamera = new THREE.CubeCamera(1, 10000, 512);
      this.cubeCamera.name = 'cubecamera'
      this.cubeCamera.renderTarget.texture.minFilter = THREE.LinearMipMapLinearFilter;
      // this.cubeCamera.renderTarget.texture.format = THREE.RGBAFormat;
      this.cubeCamera.position.x = -15;
      this.cubeCamera.position.y = 595;
      this.cubeCamera.position.z = 30;
      this.cubeCamera.matrixWorldNeedsUpdate = true;
      this.cubeCamera.renderTarget.texture.mapping = THREE.CubeReflectionMapping;
      this.scene.add(this.cubeCamera);
      this.cubeCamera2 = new THREE.CubeCamera(1, 10000, 128);
      this.cubeCamera2.name = 'cubecamera2'
      this.cubeCamera2.renderTarget.texture.minFilter = THREE.LinearMipMapLinearFilter;
      this.scene.add(this.cubeCamera2);
    },
    initSphere() {
      var SphereMaterial = new THREE.MeshPhysicalMaterial({
        color: 0xffffff,
        reflectivity: 0.99,
        metalness: 0.99,
        roughness: 0,
        envMap: this.cubeCamera.renderTarget.texture
      });
      var SphereGeometry = new THREE.SphereBufferGeometry(100, 16, 16);
      this.sphere = new THREE.Mesh(SphereGeometry, SphereMaterial);
      this.sphere.name = 'sphere'
      this.sphere.position.x = -15;
      this.sphere.position.y = 595;
      this.sphere.position.z = 30;
      this.sphere.castShadow = true;
      this.sphere.receiveShadow = true;
      this.sphere.scale.setScalar(1.9);
      this.group.add(this.sphere);


    },
    initLights() {
      this.ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
      this.scene.add(this.ambientLight);

      this.light = new THREE.DirectionalLight(0xffffff, 1);
      this.light.castShadow = true;
      this.scene.add(this.light);
      this.light.name = 'light';
      this.light.shadow.camera.bottom = -this.options.shadowClip;
      this.light.shadow.camera.top = this.options.shadowClip;
      this.light.shadow.camera.left = -this.options.shadowClip;
      this.light.shadow.camera.right = this.options.shadowClip;
      this.light.shadow.mapSize.width = 512;
      this.light.shadow.mapSize.height = 512;
      // this.light.shadow.camera.near = 0.1;
      this.light.shadow.camera.far = 6000;
      this.light.shadow.bias = -0.0002;

      // this.light.shadow.radius = 2;

      // var helper = new THREE.CameraHelper(this.light.shadow.camera);
      // this.scene.add(helper);
    },
    initSkybox() {
      const Sky = require('three-sky');
      const sky = new Sky();
      this.sky = sky;
      this.sky.scale.setScalar(6000);
      this.scene.add(sky);
      var uniforms = this.sky.material.uniforms;
      uniforms.turbidity.value = 10;
      uniforms.rayleigh.value = 2;
      uniforms.luminance.value = 1;
      uniforms.mieCoefficient.value = 0.03;
      uniforms.mieDirectionalG.value = 0.95;
      this.updateSun();
    },
    initNightSky() {
      this.tex_night = this.texLoader.load('static/milkyway-min.jpg');
      this.tex_night.generateMipmaps = false;
      this.tex_night.minFilter = THREE.LinearFilter;
      var nightSkyMaterial = new THREE.MeshBasicMaterial({
        color: 0xffffff,
        map: this.tex_night,
        side: THREE.BackSide,
        transparent: true,
        opacity: 0
      });

      var nightSkyGeometry = new THREE.SphereBufferGeometry(1, 12, 12);
      this.nightSky = new THREE.Mesh(nightSkyGeometry, nightSkyMaterial);
      this.nightSky.scale.setScalar(5500);
      this.nightSky.rotation.x = 3;
      this.nightSky.rotation.z = 5.2;
      this.nightSky.name = 'nightsky';
      this.scene.add(this.nightSky);
    },
    initShadowPlane() {
      var shadowPlaneGeometry = new THREE.PlaneBufferGeometry();
      var shadowPlaneMaterial = new THREE.ShadowMaterial({
        //side: THREE.DoubleSide
      });
      shadowPlaneMaterial.opacity = 0.7;
      this.shadowPlane = new THREE.Mesh(shadowPlaneGeometry, shadowPlaneMaterial);
      this.shadowPlane.rotation.x = -Math.PI / 2;
      this.shadowPlane.receiveShadow = true;
      this.shadowPlane.scale.setScalar(8000);

      this.shadowPlane.name = "shadowplane";
      this.scene.add(this.shadowPlane);
    },
    initModel() {
      var loader = new THREE.GLTFLoader(this.manager);
      var self = this;
      var tex_normals = this.texLoader.load('static/NORM_flipped.jpg');
      tex_normals.generateMipmaps = false;
      tex_normals.minFilter = THREE.LinearFilter;


      self.modelMaterial = new THREE.MeshPhysicalMaterial({
        color: 0xffffff,
        normalMap: tex_normals,
        reflectivity: 1,
        metalness: 0.95,
        roughness: 0.35,
        normalScale: new THREE.Vector2(1.5, 1.5),
        envMap: this.cubeCamera2.renderTarget.texture
      });
      self.modelMaterial.flatShading = false;
      loader.load(
        'static/Hand_final.gltf',
        function(gltf) {
          self.model = gltf.scene.children[0];
          self.model.name = 'model';

          self.model.position.y = 400;
          self.model.position.z = 0;
          self.model.scale.setScalar(60);
          self.model.rotation.y = 9.32;
          self.model.rotation.x = 0;
          self.model.material = self.modelMaterial;
          self.model.castShadow = true;
          self.model.receiveShadow = true;
          self.group.add(gltf.scene.children[0]);
          self.loaded = true;
        },
        function(xhr) {

          //console.log((xhr.loaded / xhr.total * 100) + '% loaded');

        },
        function(error) {
          console.log('An error happened during the load of the hand model. Please reload or contact artur@selam-x.com');
          console.log(error);
        }
      );
    },

    updateSun() {
      var theta = Math.PI * (this.sunParameters.inclination - 0.5);
      var phi = 2 * Math.PI * (this.sunParameters.azimuth - 0.5);
      this.light.position.x = this.sunParameters.distance * Math.cos(phi);
      this.light.position.y = this.sunParameters.distance * Math.sin(phi) * Math.sin(theta);
      this.light.position.z = this.sunParameters.distance * Math.sin(phi) * Math.cos(theta);
      this.sky.material.uniforms.sunPosition.value = this.light.position.copy(this.light.position);
      if (this.sunParameters.azimuth > 0.5) {
        this.isNight = true;
      } else {
        this.isNight = false;
      }
    },
    animateScene() {
      var self = this;

      if (this.animation.start) {

        anime({
          targets: self.camera,
          duration: self.animation.duration,
          elasticity: 0,
          easing: 'easeInOutSine',
          fov: {
            value: [self.cameraParameters.fov, 60],
          },
          delay: self.animation.delay,
          loop: false,
          complete: function(anim) {
            self.animation.finished = true;
            self.loadingScreen.style.display = 'none';
          }
        })

        anime({
          targets: self.camera.position,
          duration: self.animation.duration,
          elasticity: 0,
          easing: 'easeOutSine',
          x: {
            value: [-170, -700],
          },
          y: {
            value: [self.cameraParameters.focalPoint.y, 400],
          },
          z: {
            value: [170, 700],
          },
          delay: self.animation.delay,
          loop: false,
          update: function() {
            self.camera.updateProjectionMatrix();

          }
        })
        setTimeout(function() {

          anime({
            targets: self.sphere.position,
            y: {

              value: [595, 700],
              duration: self.animation.dayCycle / 2,
              easing: 'easeInOutSine',
              elasticity: 250

            },
            // delay: self.animation.dayCycle / 2,
            direction: 'alternate',
            loop: true
          })

          anime({
            targets: self.sunParameters,
            azimuth: {
              value: [0, 1],
              duration: self.animation.dayCycle,
              easing: 'linear',
              elasticity: 0
            },
            loop: true,
            update: function(anim) {
              self.updateSun();
            }
          });

        }, self.animation.delay);

      }
    },
    onOrientationchange() {
      var self = this;
      var afterOrientationChange = function() {
        //  console.log(document.documentElement.clientWidth, document.documentElement.clientHeight);
        self.rendererThree.setSize(document.documentElement.clientWidth, document.documentElement.clientHeight);
        self.camera.aspect = document.documentElement.clientWidth / document.documentElement.clientHeight;
        self.camera.updateProjectionMatrix();
        window.removeEventListener('resize', afterOrientationChange);
      };
      window.addEventListener('resize', afterOrientationChange);
    },
    onResize() {
      this.rendererThree.setSize(window.innerWidth, window.innerHeight);
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
    },
    initEvents() {
      window.addEventListener('resize', this.onResize);
      window.addEventListener('orientationchange', this.onOrientationchange);
      var self = this;

      function konami(callback) {
        let kkeys = [];
        // up,up,down,down,left,right,left,right,B,A
        const konami = '38,38,40,40,37,39,37,39,66,65';
        return event => {
          kkeys.push(event.keyCode);
          //console.log(kkeys);
          if (kkeys.toString().indexOf(konami) >= 0) {
            callback();
            kkeys = [];
          }
        };
      }
      const handler = konami(() => {
        //  console.log('konami 1');
        var tex_normals = self.model.material.normalMap;
        self.model.material.displacementMap = tex_normals;
        self.model.material.displacementScale = 0;
        anime({
          targets: self.model.material,
          displacementScale: [0, 1],
          duration: self.animation.dayCycle,
          elasticity: 1000,
          loop: false
        });

        function showMessage(message) {
          var h2 = document.createElement('h2');
          var div = document.createElement('div');
          div.id = 'konami';
          div.style.position = 'fixed';
          div.style.height = '100vh';
          div.style.width = '100vw';
          div.style.top = 0;
          div.style.left = 0;
          div.style.zIndex = 3;
          div.style.display = 'flex';
          div.style.justifyContent = 'center';
          div.style.pointerEvents = 'none';
          div.style.alignItems = 'center';
          h2.style.fontSize = '1.5em';
          h2.style.color = 'white';
          var konami = document.getElementById("loading-screen");

          konami.parentElement.append(div);
          div.appendChild(h2);
          h2.appendChild(document.createTextNode(message));

          setTimeout(function() {
            div.parentNode.removeChild(div);
          }, 2000);

          return false;
        }

        showMessage('Fat Finger Mode unlocked');



      });
      window.addEventListener('keydown', handler);

    },
    formatToPercent(value) {
      return `${Number(value).toFixed(0)}%`;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('orientationchange', this.onOrientationchange);
  },
  mounted() {
    this.init();
    this.initEvents();


    console.log("%cMETAMARATHON 2019, STAY TUNED FOR UPDATES ", "font-size:30px");

    console.log("%cWEBSITE BY %cwww.selam-x.com", "font-size:30px", "font-size:30px; text-decoration: underline; text-transform: uppercase");

  },
  watch: {

    isNight() {

      if (this.isNight) {
        anime({
          targets: this.nightSky.material,
          opacity: [0.05, 1],
          duration: 400,
          easing: 'linear'
        });
        anime({
          targets: this.ambientLight,
          intensity: [1, 0.1],
          duration: 250,
          easing: 'easeInQuad'
        });
        anime({
          targets: this.light,
          intensity: [1, 0],
          duration: 250,
          easing: 'easeInQuad'
        });
        // this.light.intensity = 1;
        // this.ambientLight.intensity = 1;
      } else {
        anime({
          targets: this.nightSky.material,
          opacity: [1, 0.05],
          duration: 400,
          easing: 'linear'
        });
        anime({
          targets: this.ambientLight,
          intensity: [0.1, 1],
          duration: 250,
          easing: 'easeInQuad'
        });
        anime({
          targets: this.light,
          intensity: [0, 1],
          duration: 250,
          easing: 'easeInQuad'
        });
      }
    },
    loaded(val) {
      if (this.loaded) {
        this.loadingComplete();
        this.loadingScreen = document.getElementById('loading-screen');
        this.$children[1].parentLoaded = true;
        this.loadingScreen.style.opacity = 0

        this.animation.start = true;
        this.animateScene();


      }
    }
  }

}
</script>

<style scoped>
#threeJsCanvas {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  pointer-events: none;
}

.konami {
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 1;
  transition: all 1s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

#loading-screen {
  position: absolute;
  /* pointer-events: none; */
  z-index: 3;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  opacity: 1;
  transition: all 1s ease;
  display: flex;
  justify-content: center;
  align-items: center;

}


#loader {
  color: white
}

h2 {
  font-size: 3.5em;
  font-weight: 300;
  margin: 0;
  letter-spacing: -1px;
  line-height: 1;
}

@media screen and (max-width: 768px) {

  h2 {
    font-size: 1.8em;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {

  h2 {
    font-size: 2.5em;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {

  h2 {
    font-size: 3em;
  }
}

@media screen and (max-width: 768px) and (orientation: landscape) {

  h2 {
    font-size: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mainpage.vue